import { BulletProps } from "./Bullet.types"

// The design system's inline separator glyph: a katakana middle dot, not the ASCII bullet.
export const BULLET_CHARACTER = "\u30FB"

// Decorative separator between inline segments ("Name ・ Manufacturer"). Inside plain
// strings interpolate `BULLET_CHARACTER` instead.
export default function Bullet(props: BulletProps) {
    const { className } = props

    return (
        <span className={className} aria-hidden={true}>
            {BULLET_CHARACTER}
        </span>
    )
}
